import { Box, Image } from '@chakra-ui/react';

interface IPhotoButton {
  type: 'before' | 'after';
  slotId: number;
  imagePath: string;
  onPreviewImage: (path: string) => void;
}

function PhotoButton(props: IPhotoButton) {
  return (
    <Box
      boxSize={'5rem'}
      border="1px"
      borderColor={'#eeeeee'}
      borderRadius="0.25rem"
      overflow="hidden"
      onClick={() => {
        props.onPreviewImage(props.imagePath);
      }}>
      <Image src={props.imagePath} fit="cover" w={'100%'} h={'100%'} />
    </Box>
  );
}

export default PhotoButton;
